import { IMainTableColumn } from "components/MainTable/MainTableInterfaces";
import { IRCA } from "entities/RCA/RCALibraryEntity/RCALibraryEntityInterfaces";
import RCALibraryDescriptionCell from "pages/Corporate/RCA/RCALibrary/components/useRCALibraryColumns/components/RCALibraryDescriptionCell";
import RCALibraryDueDateCell from "pages/Corporate/RCA/RCALibrary/components/useRCALibraryColumns/components/RCALibraryDueDateCell";
import RCALibraryNumberCell from "pages/Corporate/RCA/RCALibrary/components/useRCALibraryColumns/components/RCALibraryNumberCell";
import RCALibraryStatusCell from "pages/Corporate/RCA/RCALibrary/components/useRCALibraryColumns/components/RCALibraryStatusCell";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

interface IMyRCAsColumns extends Omit<IMainTableColumn, "render" | "renderExpandedRow"> {
    render: (row: IRCA) => string | JSX.Element | number;
}

const useMyRCAsColumns = () => {
    const { t } = useTranslation();

    const columns = useMemo((): IMyRCAsColumns[] => {
        return [
            {
                id: "number",
                label: t("rca.rca_library.number"),
                hideSortIcon: false,
                customStyles: { width: "20%" },
                render: (row) => <RCALibraryNumberCell rca={row} />,
            },
            {
                id: "description",
                label: t("rca.rca_library.description"),
                hideSortIcon: false,
                customStyles: { width: "40%" },
                render: (row) => <RCALibraryDescriptionCell rca={row} />,
            },
            {
                id: "due_date",
                label: t("rca.rca_library.due_date"),
                hideSortIcon: false,
                align: "center",
                customStyles: { width: "20%" },
                render: (row) => <RCALibraryDueDateCell rca={row} />,
            },
            {
                id: "status",
                label: t("rca.rca_library.status"),
                headerCustomStyles: { textAlign: "right", paddingRight: "80px" },
                hideSortIcon: false,
                customStyles: { width: "20%" },
                render: (row) => <RCALibraryStatusCell myDashboard rca={row} />,
            },
        ];
    }, [t]);

    return columns;
};

export default useMyRCAsColumns;
